
export default {
	props: ["value",'required',],
	// events: ["save",'input'],
	data() {
		return {
			saving: false,
			editing: false,
			val: this.value,
		};
	},
	watch: {
		value() {
			this.val = this.value;
		}
	},
	mounted() {
		if (this.required && !this.value) {
			this.edit();
		}
	},
	methods: {
		save() {
			this.saving = true;
			let promise;
			if (promise = this.$listeners.save?.(this.val)) {
				promise
				.then(() => this.editing = false)
				.catch(() => {})
				.finally(() => this.saving = false)
			} else {
				this.editing = false;
				this.saving = false;
			}
		},
		edit() {
			this.backup = this.val;
			this.editing = true;
			this.$nextTick(() => this.$refs.editor.focus());
		},
		cancel() {
			this.val = this.backup;
			this.$emit('input',this.val); // need to fire manually, a the value is changed programmatically
			this.editing = false;
		},
	},
};
